<app-menu-bar></app-menu-bar>

<div class="dashboard-page">
<div class="dashboard-container">
<app-dashboard-nav></app-dashboard-nav>

<div id="order">
    <div class="w-100 box order-header">
        <div class="d-flex flex-column gap-2">
            <span class="orderNo">Order #{{ order?.orderNo }}</span>
            <span class="muted-header">Created on {{ order?.createdAt | customDate }} • Last updated {{
                order?.updatedAt | customDate }}</span>
        </div>
        <div class="header-meta">
            <div class="d-flex flex-column gap-2">
                <span class="muted-header">Date</span>
                <span class="value">{{ order?.createdAt | customDate }}</span>
            </div>
            <div class="d-flex flex-column gap-2">
                <span class="muted-header">Assigned to</span>
                @if (!order?.assignedTo) { <button class="primary-btn" [disabled]="takingOrder"
                    (click)="takeOrder(order)">{{ takingOrder ? 'Taking…' : 'Take' }}</button>}
                @if (order?.assignedTo) { <span class="value">{{ order.assignedTo }}</span>}
            </div>
            <div class="d-flex flex-column gap-2">
                <span class="muted-header">Status</span>
                <!-- Unassigned orders show the status as plain text: it stays on
                     'New' until someone takes the order. -->
                @if (order?.assignedTo) {
                    <!-- [ngModel] + (ngModelChange) rather than banana-in-a-box: the
                         handler rolls the selection back if the save fails. -->
                    <ng-select #statusSelect class="fyes-select status-select" [items]="statuses" bindLabel="title"
                        bindValue="id"
                        [ngModel]="statusId" (ngModelChange)="onStatusChange($event)" [clearable]="false"
                        [searchable]="false" [disabled]="savingStatus" placeholder="Set status">
                    </ng-select>
                } @else {
                    <span class="value" title="Take the order to change its status">{{ currentStatusTitle }}</span>
                }
            </div>
        </div>
    </div>
    <div class="order-columns">
        <div class="d-flex flex-column flex-grow-1 gap-3">
            <div class="box order-details">
                <span class="header">Contact Details</span>
                <div class="d-flex flex-column gap-2">
                    <span class="muted-header">Email</span>
                    <span class="value">{{ order?.contactDetails.email }}</span>
                </div>
                <div class="d-flex flex-column gap-2">
                    <span class="muted-header">Phone</span>
                    <span class="value">{{ order?.contactDetails.phone }}</span>
                </div>
            </div>
            <div class="box order-details">
                <span class="header">Order Details</span>
                <div class="d-flex flex-column gap-2">
                    <span class="muted-header">Space type</span>
                    <span class="value">{{ order?.spaceType }}</span>
                </div>
                <div class="d-flex flex-column gap-2">
                    <span class="muted-header">Size</span>
                    <span class="value">{{ order?.size }} sq</span>
                </div>
                <div class="d-flex flex-column gap-2">
                    <span class="muted-header">No. of rooms</span>
                    <span class="value">{{ order?.rooms }}</span>
                </div>
                <div class="d-flex flex-column gap-2">
                    <span class="muted-header">Automations</span>
                    <div class="d-flex gap-2 flex-wrap">
                        @for (automation of order?.automations; track $index) {
                        <div class="pill">
                            <span>{{automation.title}}</span>
                        </div>
                        }
                    </div>
                </div>
                <div class="price-area">
                    <div class="price-details">
                        <div class="d-flex justify-content-between gap-5">
                            <span class="muted-header">Item subtotal</span>
                            <span class="muted-header">{{ order?.totalPrice }}</span>
                        </div>
                        <div class="d-flex justify-content-between">
                            <span class="muted-header">Discount</span>
                            <span class="muted-header">0</span>
                        </div>
                        <div class="d-flex justify-content-between">
                            <span class="value">Order Total</span>
                            <span class="value">{{ order?.totalPrice }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="comment-box box order-details">
            <span class="header">Comments</span>
            @for (comment of order?.comments; track $index) {
            <div class="comment">
                <span class="text" style="color: #FFFFFF;">{{ comment.comment }}</span>
                <span class="muted-text">{{ comment.date | customDate }}</span>
                <span class="muted-text">by {{comment.commentedBy}}</span>
            </div>
            }
            <div class="d-flex flex-column gap-2">
                <span class="muted-header">Add note</span>
                <textarea rows="4" class="fyes-input" placeholder="Write your note and press enter"
                    [(ngModel)]="newComment" (keydown.enter)="onEnterPress($event)"></textarea>
            </div>
        </div>
    </div>
</div>
</div>
</div>

<app-footer></app-footer>